import {type FC} from "react"
import {Box, Stack} from "@mui/material"
import {ArrowLeftIcon, ArrowRightIcon} from "../../../assets"

type Props = {
  actualPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

const Pagination: FC<Props> = (props) => {
  const {actualPage, totalPages} = props

  const handlePreviousPage = () => {
    actualPage > 0 && props.onPageChange(actualPage - 1)
  }

  const handleNextPage = () => {
    props.onPageChange(actualPage < totalPages - 1 ? actualPage + 1 : 0)
  }

  return (
    <Stack direction="row" spacing={1}>
      <Box
        sx={{
          width: "20px",
          height: "20px",
          borderRadius: "50%",
          backgroundColor: actualPage === 0 ? "#20385526" : "#00adc2",
          textAlign: "center",
          paddingTop: "2px",
          marginRight: "13px",
          cursor: "pointer",
        }}
        onClick={handlePreviousPage}
      >
        <ArrowLeftIcon
          style={{
            height: "23px",
            width: "23px",
            fill: actualPage === 0 ? "#a6a6a6" : "#fff",
          }}
        />
      </Box>
      <Box width={52}>
        <span
          style={{
            fontSize: "14px",
            color: "#8b8b8a",
            textAlign: "center",
          }}
        >
          &nbsp;{actualPage + 1} / {totalPages}&nbsp;
        </span>
      </Box>
      <Box
        sx={{
          width: "20px",
          height: "20px",
          borderRadius: "50%",
          backgroundColor: "#00adc2",
          textAlign: "center",
          paddingTop: "2px",
          paddingLeft: "3px",
          marginLeft: "13px",
          cursor: "pointer",
        }}
        onClick={handleNextPage}
      >
        <ArrowRightIcon />
      </Box>
    </Stack>
  )
}

export default Pagination
